import IntlMessage from "../../helpers/intlMessage";
import React from "react";

export const arquivamentoTipoEmum = {
  BLOCO: 0,
  LAMINA: 1
};

export function retornaTipo(tipo, intl) {
  switch (tipo) {
    case arquivamentoTipoEmum.BLOCO:
      return `${intl.formatMessage({id: 'general.materialArchiving.block'})}`;
    case arquivamentoTipoEmum.LAMINA:
      return `${intl.formatMessage({id: 'general.materialArchiving.blade'})}`;
    default:
      return '';
  }
}

export function retornaIconeDestino(tipo) {
  switch (tipo) {
    case requisicaoMaterialTipoEntregaEmum.HISTOLOGIA_LAMINAS:
      return 'fas fa-microscope';
    case requisicaoMaterialTipoEntregaEmum.IMUNOLOGIA_LAMINAS:
      return 'fas fa-eye-dropper';
    case requisicaoMaterialTipoEntregaEmum.PACIENTE:
      return 'fas fa-hospital-user';
    default:
      return '';
  }
}

export function retornaIcone(tipo) {
  return tipo === arquivamentoTipoEmum.BLOCO ? 'fas fa-cube' : 'fab fa-buffer';
}

export const arquivamentoStatusEmum = {
  PENDENTE: 0,
  ARQUIVADO: 1
};

export const arquivamentoManualTipoEmum = {
  BLOCO: 0,
  LAMINA: 1,
  BLOCO_LAMINA: 2
};

export const arquivamentoManualTipoOptions = [
  {
    value: arquivamentoManualTipoEmum.BLOCO,
    label: <IntlMessage id="general.materialArchiving.blocks" />
  },
  {
    value: arquivamentoManualTipoEmum.LAMINA,
    label: <IntlMessage id="general.materialArchiving.blades" />
  },
  {
    value: arquivamentoManualTipoEmum.BLOCO_LAMINA,
    label: <IntlMessage id="general.materialArchiving.blocksAndBlades" />
  }
];

export const requisicaoMaterialTipoEntregaEmum = {
  NAO_INFORMADO: 0,
  PACIENTE: 1,
  HISTOLOGIA_LAMINAS: 2,
  IMUNOLOGIA_LAMINAS: 3
};

export const requisicaoMaterialTipoEntregaOptions = [
  {
    value: requisicaoMaterialTipoEntregaEmum.NAO_INFORMADO,
    label: <IntlMessage id="general.materialArchiving.uninformed" />
  },
  {
    value: requisicaoMaterialTipoEntregaEmum.PACIENTE,
    label: <IntlMessage id='general.materialArchiving.deliveredToThePatient' />
  },
  {
    value: requisicaoMaterialTipoEntregaEmum.HISTOLOGIA_LAMINAS,
    label: <IntlMessage id='general.materialArchiving.shouldBeForwardedToHistologySlides' />
  },
  {
    value: requisicaoMaterialTipoEntregaEmum.IMUNOLOGIA_LAMINAS,
    label: <IntlMessage id='general.materialArchiving.shouldBeForwardedImmunologySlides' />
  }
];

export const tipoArquivamentoEmum = {
  AUDITORIA: 1,
  ARQUIVAMENTO: 2,
  REQUISICAO: 3
};

export const tipoArquivamentoOptions = (intl) => {
  return [
    {
      value: tipoArquivamentoEmum.AUDITORIA,
      label: `${intl.formatMessage({id: 'general.materialArchiving.audit'})}`
    },
    {
      value: tipoArquivamentoEmum.ARQUIVAMENTO,
      label: `${intl.formatMessage({id: 'general.materialArchiving.archiving'})}`
    },
    {
      value: tipoArquivamentoEmum.REQUISICAO,
      label: `${intl.formatMessage({id: 'general.materialArchiving.request'})}`
    }
  ];
} 

export const optionsFiltroArquivamento = [
  { value: 'dtpedido', label: <IntlMessage id='general.materialArchiving.requestDate' /> },
  { value: 'dtarquivamento', label: <IntlMessage id='general.materialArchiving.filingDate' /> },
  { value: 'dtdevolucao', label: <IntlMessage id='general.materialArchiving.expectedReturnDate' /> },
  { value: 'nrExame', label: <IntlMessage id='general.materialArchiving.examNumber' /> }
];



// WEBPACK FOOTER //
// ./src/pages/arquivamento/arquivamento.utils.js